export default "__VITE_ASSET__CAb3phGL__"